<template>
  <div>
    <table class='table is-striped is-fullwidth'>
      <thead>
        <tr>
          <th>Selector</th>
          <th>Is Validated</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for='selector in selectors'
          :key='selector.selector'
          style='cursor: pointer'
          @click='$emit("rowClicked", selector)'
        >
          <td>{{ selector.selector }}</td>
          <td>{{ !!selector.validatedAt }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SelectorList',

  props: {
    selectors: {
      type: Array,
      default: () => []
    }
  }
}
</script>